import _ from 'lodash';

export function display(location) {
  if (!location) return '';
  if (location.zip && !location.address) return cityAndZip(location);
  return [
    location.address + ',',
    location.city,
    location.state,
    location.zip
  ].join(' ');
}

export function street(location) {
  return location.address || '';
}

export function cityAndZip(location) {
  if (location.city && location.state && location.zip) {
    return `${location.city}, ${location.state} ${location.zip}`;
  } else {
    return '';
  }
}

export function validPhone(value) {
  return formatPhone(value).match(/\d{10}/);
}

export function formatPhone(value) {
  return value ? value.replace('+1', '').replace(/[^\d]/g, '') : '';
}

export function validEmail(value) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);
}

export function isEqual(a, b) {
  return display(a) === display(b);
}

export function parseAddress(place) {
  var address = {};
  var componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name'
  };
  var typeMap = {
    street_number: 'number',
    route: 'street',
    locality: 'city',
    administrative_area_level_1: 'state',
    postal_code: 'zip'
  };

  if (!place.address_components) return;

  for (var i = 0; i < place.address_components.length; i++) {
    var addressType = place.address_components[i].types[0];
    if (typeMap[addressType]) {
      var val = place.address_components[i][componentForm[addressType]];
      address[typeMap[addressType]] = val;
    }
  }
  if (address.street) {
    address.address = _.compact([address.number, address.street]).join(' ');
  }
  address.lat = place.geometry.location.lat();
  address.lng = place.geometry.location.lng();
  return address;
}

export function parseSavedAddresses(addresses = []) {
  const coordinates = address => {
    return (address.location && address.location.coordinates) || [];
  };

  return addresses.map(address => ({
    clientId: address.client_id,
    lng: coordinates(address)[0],
    lat: coordinates(address)[1],
    address: address.street_address,
    city: address.city,
    state: address.state,
    zip: address.zip_code,
    unit: address.unit_number,
    notes: address.delivery_notes,
    icon_type: address.icon_type,
    type: address.residential ? 'Residential' : 'Business',
    saved: address.saved,
    recent: address.recent,
    name: address.name,
    label: address.special_case,
    businessName: address.business_name,
    businessPhone: address.business_phone
  }));
}

export function vendorIsStale(address = {}) {
  if (typeof address.shipping === 'undefined') return true;
  const vendor = address.vendor;
  if (_.isEmpty(vendor)) return true;
  if (_.isEmpty(vendor.hours)) return true;
  const close = vendor.hours.close * 1000;
  const now = +new Date();
  return close < now;
}



// WEBPACK FOOTER //
// ./shared/models/address.js